// @flow
import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { useDispatch } from 'react-redux'
import { reduxForm, SubmissionError } from 'redux-form'
import Typography from '@material-ui/core/Typography'
import DialogContent from '@material-ui/core/DialogContent'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import TextField from 'src/components/atoms/TextField'
import Button from 'src/components/atoms/buttons/Button'
import { updateUserAction } from 'src/state/actions/profile'
import { requiredField } from 'src/utils/fieldValidators'
import type { ReduxFormProps } from 'src/utils/types'

export const FORM_ID = 'editBio'

const useStyles = makeStyles(theme => ({
  modalTitle: {
    fontWeight: 'bold'
  },
  dialog: {
    margin: 0,
    minWidth: 500,
    [theme.breakpoints.down('xs')]: {
      minWidth: 0,
      width: '90vw'
    }
  },
  dialogContent: {
    width: '100%',
    height: 'auto',
    minHeight: 75
  },
  dialogActions: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
  }
}))

type EditBioProps = {
  bio: string,
  isOpen?: boolean,
  onClose: () => void
}

export const EditBioForm = ({
  bio,
  pristine,
  submitting,
  invalid,
  error,
  isOpen,
  onClose,
  handleSubmit,
  ...props
}: EditBioProps & ReduxFormProps) => {
  const styles = useStyles()
  const dispatch = useDispatch()

  return (
    <Dialog
      aria-labelledby="edit-bio-dialog-title"
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        className: styles.dialog
      }}
    >
      <form
        onSubmit={handleSubmit(async ({ bio }) => {
          try {
            await dispatch(updateUserAction({ fields: { profile: { bio } } }))
            onClose()
          } catch (errors) {
            throw new SubmissionError(errors)
          }
        })}
      >
        <DialogTitle>
          <Typography
            variant="h5"
            id="edit-bio-dialog-title"
            className={styles.modalTitle}
          >
            Edit Biography
          </Typography>
        </DialogTitle>
        <DialogContent className={styles.dialogContent}>
          <TextField
            required
            id="edit-bio-field"
            name="bio"
            wrap="hard"
            placeholder={bio ? bio : 'Enter bio here...'}
            label="Biography"
            validators={[requiredField]}
            multiline
            fullWidth
          />
        </DialogContent>
        <DialogActions className={styles.dialogActions}>
          <Button onClick={onClose}>CANCEL</Button>
          <Button
            type="submit"
            color="secondary"
            variant="contained"
            disabled={pristine || submitting || invalid}
            loading={submitting}
          >
            SUBMIT
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default reduxForm({
  form: FORM_ID
})(EditBioForm)
